import React, { useEffect, useState } from 'react';
import { getLiquidacionImpuestos, API_BASE } from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 });
const primerDiaMes = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`; };
const hoyStr = () => new Date().toISOString().slice(0, 10);

// Presets rápidos de período
const bimestre = () => { const d = new Date(); const m = d.getMonth(); const ini = m - (m % 2); return { desde: `${d.getFullYear()}-${String(ini + 1).padStart(2, '0')}-01`, hasta: hoyStr() }; };

export default function Impuestos() {
  const [desde, setDesde] = useState(primerDiaMes());
  const [hasta, setHasta] = useState(hoyStr());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const cargar = () => {
    setLoading(true); setErr('');
    getLiquidacionImpuestos(desde, hasta)
      .then(r => setData(r.data))
      .catch(e => setErr(e.response?.data?.error || 'Error al cargar'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, []);

  const setRango = (d, h) => { setDesde(d); setHasta(h); };

  const [exportando, setExportando] = useState(false);
  const exportarExcel = async () => {
    setExportando(true);
    try {
      const token = localStorage.getItem('erp_token');
      const resp = await fetch(`${API_BASE}/api/impuestos/exportar?desde=${desde}&hasta=${hasta}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!resp.ok) throw new Error('No se pudo exportar');
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `liquidacion_impuestos_${desde}_a_${hasta}.xlsx`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) { alert('No se pudo exportar el Excel'); }
    finally { setExportando(false); }
  };

  return (
    <div>
      <div style={s.header}>
        <div><h1 style={s.h1}>🧮 Liquidación de impuestos</h1><p style={s.sub}>IVA y retenciones del período, para las declaraciones</p></div>
        <button style={s.btnExport} disabled={exportando} onClick={exportarExcel}>{exportando ? 'Generando…' : '⬇ Exportar Excel'}</button>
      </div>

      <div style={s.barra}>
        <div style={s.campo}><label style={s.lbl}>Desde</label><input style={s.input} type="date" value={desde} onChange={e => setDesde(e.target.value)} /></div>
        <div style={s.campo}><label style={s.lbl}>Hasta</label><input style={s.input} type="date" value={hasta} onChange={e => setHasta(e.target.value)} /></div>
        <button style={s.btnPri} onClick={cargar}>Consultar</button>
        <div style={{ display: 'flex', gap: 6, marginLeft: 'auto' }}>
          <button style={s.chip} onClick={() => { setRango(primerDiaMes(), hoyStr()); }}>Este mes</button>
          <button style={s.chip} onClick={() => { const b = bimestre(); setRango(b.desde, b.hasta); }}>Bimestre</button>
          <button style={s.chip} onClick={() => { const y = new Date().getFullYear(); setRango(`${y}-01-01`, hoyStr()); }}>Año</button>
        </div>
      </div>

      {err && <div style={s.error}>{err}</div>}
      {loading && <p style={{ color: '#64748b', padding: 20 }}>Cargando…</p>}

      {data && !loading && (
        <>
          {/* IVA */}
          <div style={s.card}>
            <h2 style={s.cardTitle}>IVA</h2>
            <table style={s.table}>
              <tbody>
                {data.iva.n_nc_ventas > 0 && (
                  <>
                    <tr><td style={s.td}>IVA de facturas de venta</td><td style={s.tdSub}>{data.iva.n_ventas} fact.</td><td style={s.tdVal}>{fmt(data.iva.generado_facturas)}</td></tr>
                    <tr><td style={{ ...s.td, color: '#94a3b8' }}>(−) IVA en notas crédito</td><td style={s.tdSub}>{data.iva.n_nc_ventas} NC</td><td style={{ ...s.tdVal, color: '#94a3b8' }}>−{fmt(data.iva.generado_nc)}</td></tr>
                  </>
                )}
                <tr><td style={s.td}>{data.iva.n_nc_ventas > 0 ? '= IVA generado (neto)' : 'IVA generado (ventas)'}</td><td style={s.tdSub}>base {fmt(data.iva.base_ventas)}</td><td style={s.tdVal}>{fmt(data.iva.generado)}</td></tr>
                {data.iva.n_nc_compras > 0 && (
                  <>
                    <tr><td style={s.td}>IVA de facturas de compra</td><td style={s.tdSub}>{data.iva.n_compras} fact.</td><td style={s.tdVal}>{fmt(data.iva.descontable_facturas)}</td></tr>
                    <tr><td style={{ ...s.td, color: '#94a3b8' }}>(−) IVA en notas crédito recibidas</td><td style={s.tdSub}>{data.iva.n_nc_compras} NC</td><td style={{ ...s.tdVal, color: '#94a3b8' }}>−{fmt(data.iva.descontable_nc)}</td></tr>
                  </>
                )}
                <tr><td style={s.td}>(−) {data.iva.n_nc_compras > 0 ? '= IVA descontable (neto)' : 'IVA descontable (compras)'}</td><td style={s.tdSub}>base {fmt(data.iva.base_compras)}</td><td style={s.tdVal}>{fmt(data.iva.descontable)}</td></tr>
                <tr><td style={s.td}>= IVA del período</td><td /><td style={s.tdVal}>{fmt(data.iva.neto)}</td></tr>
                {data.retenciones_a_favor.reteiva > 0 && (
                  <tr><td style={{ ...s.td, color: '#94a3b8' }}>(−) ReteIVA a favor (te lo practicaron)</td><td /><td style={{ ...s.tdVal, color: '#94a3b8' }}>−{fmt(data.retenciones_a_favor.reteiva)}</td></tr>
                )}
                {(() => {
                  const saldoIva = data.iva.neto - Number(data.retenciones_a_favor.reteiva || 0);
                  return (
                    <tr style={s.trTotal}>
                      <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }} colSpan={2}>{saldoIva >= 0 ? 'Saldo IVA a pagar' : 'Saldo a favor en IVA'}</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, fontSize: 18, color: saldoIva >= 0 ? '#f59e0b' : '#10b981' }}>{fmt(Math.abs(saldoIva))}</td>
                    </tr>
                  );
                })()}
              </tbody>
            </table>
          </div>

          {/* Notas crédito emitidas — control para cuadrar contra la DIAN */}
          {data.notas_credito && data.notas_credito.n > 0 && (
            <div style={s.card}>
              <h2 style={s.cardTitle}>Notas crédito emitidas — control DIAN ({data.notas_credito.n})</h2>
              <table style={s.table}>
                <thead>
                  <tr>
                    <th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Número</th>
                    <th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Fecha</th>
                    <th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Cliente</th>
                    <th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Factura afectada</th>
                    <th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>Subtotal</th>
                    <th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>IVA</th>
                    <th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>Total</th>
                    <th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {(data.notas_credito.detalle || []).map((r, i) => {
                    const noTransmitida = ['borrador', 'anulada'].includes(r.estado);
                    return (
                    <tr key={i}>
                      <td style={s.td}>{r.numero}</td>
                      <td style={s.td}>{(r.fecha || '').slice(0, 10)}</td>
                      <td style={s.td}>{r.cliente}</td>
                      <td style={s.td}>{r.factura_ref || '—'}</td>
                      <td style={s.tdVal}>{fmt(r.subtotal)}</td>
                      <td style={s.tdVal}>{fmt(r.iva)}</td>
                      <td style={s.tdVal}>{fmt(r.total)}</td>
                      <td style={{ ...s.td, color: noTransmitida ? '#fbbf24' : '#94a3b8', fontSize: 12 }}>{noTransmitida ? '⚠️ ' : ''}{r.estado}</td>
                    </tr>
                    );
                  })}
                  <tr style={s.trTotal}>
                    <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }} colSpan={4}>Total notas crédito</td>
                    <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(data.notas_credito.base)}</td>
                    <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(data.notas_credito.iva)}</td>
                    <td style={{ ...s.tdVal, fontWeight: 700, fontSize: 16, color: '#f59e0b' }}>{fmt(data.notas_credito.total)}</td>
                    <td style={s.td} />
                  </tr>
                </tbody>
              </table>
              <p style={s.nota}>Compara este <strong>total ({fmt(data.notas_credito.total)})</strong> y la cantidad de notas ({data.notas_credito.n}) contra lo que reporta la DIAN. Si la DIAN muestra menos, revisa cuáles NC no quedaron aceptadas/transmitidas. El IVA de estas notas ya se resta del IVA generado de arriba.</p>
            </div>
          )}

          {/* Bases de venta por tarifa (gravadas vs exentas/excluidas) */}
          {data.iva.bases_venta && (data.iva.bases_venta.gravadas?.length > 0 || data.iva.bases_venta.total > 0) && (() => {
            const b = data.iva.bases_venta;
            return (
              <div style={s.card}>
                <h2 style={s.cardTitle}>Bases de venta (para la declaración de IVA)</h2>
                <table style={s.table}>
                  <tbody>
                    {(b.gravadas || []).map((g, i) => (
                      <tr key={i}><td style={s.td}>Base gravada</td><td style={s.tdSub}>{g.tarifa}%</td><td style={s.tdVal}>{fmt(g.base)}</td></tr>
                    ))}
                    {b.exenta > 0 && <tr><td style={s.td}>Base exenta</td><td style={s.tdSub}>0% con derecho a descontable</td><td style={s.tdVal}>{fmt(b.exenta)}</td></tr>}
                    {b.excluida > 0 && <tr><td style={s.td}>Base excluida</td><td style={s.tdSub}>no causa IVA</td><td style={s.tdVal}>{fmt(b.excluida)}</td></tr>}
                    {b.sin_clasificar > 0 && <tr><td style={{ ...s.td, color: '#fbbf24' }}>Base 0% sin clasificar</td><td style={s.tdSub}>marcar en el producto</td><td style={{ ...s.tdVal, color: '#fbbf24' }}>{fmt(b.sin_clasificar)}</td></tr>}
                    <tr style={s.trTotal}>
                      <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }} colSpan={2}>Total base ventas</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, fontSize: 16, color: '#e2e8f0' }}>{fmt(b.total)}</td>
                    </tr>
                  </tbody>
                </table>
                <p style={s.nota}>El <strong>exento</strong> (0% con derecho a descontable) y el <strong>excluido</strong> (no causa IVA) se marcan en cada producto (Productos → clasificación de IVA). Lo que salga como <strong style={{ color: '#fbbf24' }}>sin clasificar</strong> es 0% sin marca: márcalo en el producto para que caiga en la casilla correcta.</p>
              </div>
            );
          })()}

          {/* Compras por tarifa de IVA (IVA descontable) */}
          {data.iva.compras_por_tarifa && data.iva.compras_por_tarifa.detalle?.length > 0 && (() => {
            const ct = data.iva.compras_por_tarifa;
            const dif = ct.total_iva - Number(data.iva.descontable || 0);
            return (
              <div style={s.card}>
                <h2 style={s.cardTitle}>Compras por tarifa de IVA (IVA descontable)</h2>
                <table style={s.table}>
                  <thead>
                    <tr><th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Tarifa</th><th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>Base</th><th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>IVA</th></tr>
                  </thead>
                  <tbody>
                    {ct.detalle.map((c, i) => (
                      <tr key={i}>
                        <td style={s.td}>{Number(c.tarifa) === 8 ? 'Gravadas al 8% (impoconsumo, no IVA)' : Number(c.tarifa) > 0 ? `Gravadas al ${Number(c.tarifa)}%` : 'Compras 0% (excluidas / no gravadas)'}</td>
                        <td style={s.tdVal}>{fmt(c.base)}</td>
                        <td style={s.tdVal}>{fmt(c.iva)}</td>
                      </tr>
                    ))}
                    <tr style={s.trTotal}>
                      <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }}>Total (según detalle)</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(ct.total_base)}</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(ct.total_iva)}</td>
                    </tr>
                    <tr>
                      <td style={s.td} colSpan={2}>IVA descontable declarado (encabezados)</td>
                      <td style={s.tdVal}>{fmt(data.iva.descontable)}</td>
                    </tr>
                  </tbody>
                </table>
                <p style={s.nota}>Si hay tarifas distintas al 19% (por ejemplo 8% o 5%), quedan discriminadas aquí. El total del detalle sale de los ítems del XML y puede diferir {Math.abs(dif) >= 1 ? `en ${fmt(Math.abs(dif))}` : 'levemente'} del descontable declarado (que sale de los encabezados) por descuentos o redondeos.</p>
              </div>
            );
          })()}

          {/* Ventas y compras por tipo (bienes / servicios) */}
          {[['Ventas por tipo (bienes / servicios)', data.iva.ventas_por_tipo, 'marca en el producto'],
            ['Compras por tipo (bienes / servicios)', data.iva.compras_por_tipo, 'marca en la factura recibida']].map(([titulo, bt, donde], k) => bt && (() => {
            const totBase = bt.bien.base + bt.servicio.base + bt.sin_clasificar.base;
            const totIva = bt.bien.iva + bt.servicio.iva + bt.sin_clasificar.iva;
            if (totBase === 0 && totIva === 0) return null;
            return (
              <div key={k} style={s.card}>
                <h2 style={s.cardTitle}>{titulo}</h2>
                <table style={s.table}>
                  <thead>
                    <tr><th style={{ ...s.td, color: '#64748b', fontWeight: 600 }}>Tipo</th><th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>Base</th><th style={{ ...s.tdVal, color: '#64748b', fontWeight: 600 }}>IVA</th></tr>
                  </thead>
                  <tbody>
                    <tr><td style={s.td}>Bienes</td><td style={s.tdVal}>{fmt(bt.bien.base)}</td><td style={s.tdVal}>{fmt(bt.bien.iva)}</td></tr>
                    <tr><td style={s.td}>Servicios</td><td style={s.tdVal}>{fmt(bt.servicio.base)}</td><td style={s.tdVal}>{fmt(bt.servicio.iva)}</td></tr>
                    {(bt.sin_clasificar.base !== 0 || bt.sin_clasificar.iva !== 0) && (
                      <tr><td style={{ ...s.td, color: '#fbbf24' }}>Sin clasificar</td><td style={{ ...s.tdVal, color: '#fbbf24' }}>{fmt(bt.sin_clasificar.base)}</td><td style={{ ...s.tdVal, color: '#fbbf24' }}>{fmt(bt.sin_clasificar.iva)}</td></tr>
                    )}
                    <tr style={s.trTotal}>
                      <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }}>Total</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(totBase)}</td>
                      <td style={{ ...s.tdVal, fontWeight: 700, color: '#e2e8f0' }}>{fmt(totIva)}</td>
                    </tr>
                  </tbody>
                </table>
                {(bt.sin_clasificar.base !== 0 || bt.sin_clasificar.iva !== 0) && (
                  <p style={s.nota}>Lo que sale como <strong style={{ color: '#fbbf24' }}>sin clasificar</strong> aún no tiene {donde}; márcalo para que caiga en bienes o servicios.</p>
                )}
              </div>
            );
          })())}

          {/* Otras retenciones a favor (NO son de IVA) */}
          <div style={s.card}>
            <h2 style={s.cardTitle}>Otras retenciones a favor (van a otras declaraciones)</h2>
            <table style={s.table}>
              <tbody>
                <tr><td style={s.td}>Retefuente a favor</td><td style={s.tdSub}>→ declaración de renta</td><td style={s.tdVal}>{fmt(data.retenciones_a_favor.retefuente)}</td></tr>
                <tr><td style={s.td}>ReteICA a favor</td><td style={s.tdSub}>→ declaración de ICA municipal</td><td style={s.tdVal}>{fmt(data.retenciones_a_favor.reteica)}</td></tr>
              </tbody>
            </table>
            <p style={s.nota}>El <strong>ReteIVA</strong> a favor no aparece aquí: se resta directamente en el bloque de IVA de arriba. La retefuente va a tu declaración de renta y el reteICA a la de ICA — <strong>no</strong> se suman con el IVA. ({data.retenciones_a_favor.n_pagos} pagos con retención en el período.)</p>
          </div>

          {/* Retenciones por pagar (que tú practicas a proveedores) */}
          {data.retenciones_por_pagar && (
            <div style={s.card}>
              <h2 style={s.cardTitle}>Retenciones que practicaste a proveedores (por pagar a la DIAN)</h2>
              <table style={s.table}>
                <tbody>
                  <tr><td style={s.td}>Retención en la fuente</td><td /><td style={s.tdVal}>{fmt(data.retenciones_por_pagar.retefuente)}</td></tr>
                  <tr><td style={s.td}>ReteIVA</td><td /><td style={s.tdVal}>{fmt(data.retenciones_por_pagar.reteiva)}</td></tr>
                  <tr><td style={s.td}>ReteICA</td><td /><td style={s.tdVal}>{fmt(data.retenciones_por_pagar.reteica)}</td></tr>
                  <tr style={s.trTotal}>
                    <td style={{ ...s.td, fontWeight: 700, color: '#f1f5f9' }} colSpan={2}>Total retenciones por pagar</td>
                    <td style={{ ...s.tdVal, fontWeight: 700, fontSize: 18, color: '#f59e0b' }}>{fmt(data.retenciones_por_pagar.total)}</td>
                  </tr>
                </tbody>
              </table>
              <p style={s.nota}>Sale de la contabilidad (cuentas 2365/2367/2368). Requiere que las facturas recibidas estén <strong>contabilizadas</strong>; si te da $0, contabilízalas en Facturas recibidas.</p>
            </div>
          )}

          <p style={s.pie}>Cálculo tomado directamente de las facturas de venta, facturas recibidas (compras) y pagos del período {data.periodo.desde} a {data.periodo.hasta}. Para el IVA descontable, asegúrate de que las facturas recibidas estén cargadas.</p>
        </>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  barra: { display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 14, marginBottom: 20 },
  campo: { display: 'flex', flexDirection: 'column', gap: 4 },
  lbl: { color: '#94a3b8', fontSize: 12 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 10px', color: '#f1f5f9', fontSize: 13, height: 38, boxSizing: 'border-box' },
  btnPri: { background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '0 18px', height: 38, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnExport: { background: '#166534', color: '#86efac', border: '1px solid #16a34a', borderRadius: 8, padding: '0 16px', height: 38, fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  chip: { background: '#0f172a', border: '1px solid #334155', color: '#94a3b8', borderRadius: 8, padding: '0 12px', height: 34, fontSize: 12, cursor: 'pointer' },
  error: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 20, marginBottom: 18 },
  cardTitle: { color: '#f1f5f9', fontSize: 15, fontWeight: 600, margin: '0 0 12px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  td: { padding: '10px 8px', color: '#cbd5e1', fontSize: 14, borderBottom: '1px solid #1a2332' },
  tdSub: { padding: '10px 8px', color: '#64748b', fontSize: 12, borderBottom: '1px solid #1a2332' },
  tdVal: { padding: '10px 8px', color: '#e2e8f0', fontSize: 14, textAlign: 'right', borderBottom: '1px solid #1a2332', fontFamily: 'ui-monospace,monospace' },
  trTotal: { background: '#0f172a' },
  nota: { color: '#64748b', fontSize: 12, margin: '12px 0 0' },
  pie: { color: '#475569', fontSize: 12, marginTop: 4 },
};
